import React from 'react'
import styled from 'styled-components'

const MyCustomButton = ({children}) => {
  return (
    <StyledButton
      onClick={() => alert("Example to demonstrate using spacer when margin isn't the best tool for the job.")}
    >
      {children}
    </StyledButton>
  )
}

const StyledButton = styled.button`
  color: #344563;
  border: transparent;
  background: transparent;
  transition: opacity 0.3s;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: 3px;
  padding: 12px 10px;
  text-decoration: none;
  font-family: inherit;
  height: 2.28571em;
  line-height: 2.28571em;
  max-width: 100%;
  transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  &:hover {
    background: rgba(222, 235, 255, 0.9);
    border: rgba(222, 235, 255, 0.9);
    text-decoration: inherit;
    transition-duration: 0s, 0.15s;
    color: #0052cc;
    cursor: pointer;
  }
  &:active {
    background: #172b4d;
  }
  &:focus {
    background: transparent;
    box-shadow: 0 0 0 2px #4c9aff;
    transition-duration: 0s, 0.2s;
    outline: none;
    color: #2c3e5d;
  }
`
export default MyCustomButton
